export const MAX_SCORE = 800;
export const MIN_SCORE = 560;
